import React, { useEffect } from 'react';
import 'react-calendar/dist/Calendar.css';
import '../../styles/DateRangePicker.css';
import './Reminders.css';
import 'react-time-picker/dist/TimePicker.css';
import 'react-clock/dist/Clock.css';
import Progress from '../Progress';
import useRemindersLogic from './hooks/useRemindersLogic';
import ReminderForm from './components/ReminderForm';
import AllRemindersView from './components/AllRemindersView';
import DeleteConfirmDialog from './components/DeleteConfirmDialog';
import SuccessDialog from './components/SuccessDialog';

const Reminders = ({
  currentPatient,
  patient,
  isOpen,
  isTeacherContext = false,
}) => {
  const {
    // State
    patientData,
    selectedPatient,
    selectedStudent,
    priority,
    time,
    textReminder,
    showCreateReminder,
    selectedDates,
    isLoading,
    allReminders,
    loading,
    successPopUp,
    openDeleteDialog,
    deleteType,
    deleteIndex,
    studentsGoalData,
    isEditing,
    typeOfUser,

    // Setters
    setSelectedPatient,
    setSelectedStudent,
    setSuccessPopUp,
    setOpenDeleteDialog,
    setDeleteType,
    setDeleteIndex,
    setShowCreateReminder,

    // Handlers
    handleDateChange,
    handleTextChangeHandler,
    handlePriorityChange,
    handleViewAllReminders,
    addTimePicker,
    deleteTimePicker,
    updateTime,
    deleteDatePicker,
    handleDeleteWithConfirmation,
    startEditReminder,
    setReminderHandler,
    fetchReminders,

    // Utilities
    truncateName,
  } = useRemindersLogic({ currentPatient, patient, isTeacherContext });

  useEffect(() => {
    if (isOpen) {
      setShowCreateReminder(true);
    }
  }, [isOpen, setShowCreateReminder]);

  if (isLoading) return <Progress />;

  return (
    <>
      {showCreateReminder ? (
        <ReminderForm
          typeOfUser={typeOfUser}
          selectedPatient={selectedPatient}
          selectedStudent={selectedStudent}
          patientData={patientData}
          studentsGoalData={studentsGoalData}
          textReminder={textReminder}
          selectedDates={selectedDates}
          time={time}
          priority={priority}
          truncateName={truncateName}
          setSelectedPatient={setSelectedPatient}
          setSelectedStudent={setSelectedStudent}
          handleTextChangeHandler={handleTextChangeHandler}
          handleDateChange={handleDateChange}
          handleDeleteWithConfirmation={handleDeleteWithConfirmation}
          updateTime={updateTime}
          addTimePicker={addTimePicker}
          handlePriorityChange={handlePriorityChange}
          handleViewAllReminders={handleViewAllReminders}
          setReminderHandler={setReminderHandler}
          isTeacherContext={isTeacherContext}
          currentEntity={patient}
          isEditing={isEditing}
          isLoading={isLoading}
        />
      ) : (
        <AllRemindersView
          allReminders={allReminders}
          selectedPatient={selectedPatient}
          fetchReminders={fetchReminders}
          loading={loading}
          setShowCreateReminder={setShowCreateReminder}
          onEditReminder={startEditReminder}
        />
      )}

      <DeleteConfirmDialog
        openDeleteDialog={openDeleteDialog}
        deleteType={deleteType}
        deleteIndex={deleteIndex}
        setOpenDeleteDialog={setOpenDeleteDialog}
        setDeleteType={setDeleteType}
        setDeleteIndex={setDeleteIndex}
        deleteDatePicker={deleteDatePicker}
        deleteTimePicker={deleteTimePicker}
      />

      <SuccessDialog
        successPopUp={successPopUp}
        setSuccessPopUp={setSuccessPopUp}
      />
    </>
  );
};

export default Reminders;
